module.exports = __webpack_public_path__ + "static/media/beatport_icon.5455a818.png";